import { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Route, Switch } from "wouter";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Upload } from "./routes/upload";
import "./style.css";

declare module "valtio" {
    function useSnapshot<T extends object>(p: T): T;
}

// Keep authenticated services (including the API-key prompt) off public pages.
const AuthenticatedApp = lazy(async () => {
    const [{ App }, { Auth }, { PostHogIdentify, PostHogWrapper }] = await Promise.all([
        import("./components/App"),
        import("./components/Auth"),
        import("./components/Posthog"),
    ]);
    return {
        default: () => (
            <PostHogWrapper>
                <Auth>
                    <PostHogIdentify>
                        <App />
                    </PostHogIdentify>
                </Auth>
            </PostHogWrapper>
        ),
    };
});

const root = document.getElementById("root");

if (!root) {
    throw new Error("root not found");
}

createRoot(root).render(
    <ErrorBoundary>
        <Suspense fallback={null}>
            <Switch>
                <Route path="/upload" component={Upload} />
                <Route component={AuthenticatedApp} />
            </Switch>
        </Suspense>
    </ErrorBoundary>,
);
